const atBreakpointChange = (breakpointToWatch, callback) => {
  const mql = window.matchMedia(`(max-width: ${breakpointToWatch}px)`);
  const onChange = () => {
    if (mql.matches) {
      callback();
    }
  }

  mql.addEventListener('change', onChange);

  const unload = () => {
    mql.removeEventListener('change', onChange);
  };

  return { unload };
};

export default atBreakpointChange;